import { notification } from 'antd';
import actions from './actions';
import { DataService } from '../../../config/dataService/dataService';

const GENERIC_API_ERROR = process.env.REACT_APP_GENERIC_ERROR_MESSAGE;

const {
  sucursalList,
  sucursalListSelectBox,
  sucursalCreate,
  sucursalRead,
  sucursalUpdate,
  sucursalDelete,
  sucursalUnidadesMedicasList,
  sucursalUnidadesMedicasClear,
} = actions;

const sucursalListAction = (paramBusqueda = '') => {
  return async dispatch => {
    try {
      const response = await DataService.get('/sucursal/list.php?paramBusqueda=' + paramBusqueda);
      if (response.status === 200 && response.data.data) {
        let registrosList = [];
        registrosList = response.data.data.map(el => {
          return { value: el.id, label: el.nombre + ' - ' + el.municipio };
        });
        dispatch(sucursalListSelectBox(registrosList));
        dispatch(sucursalList(response.data.data));
      }
      return false;
    } catch (err) {
      alert(GENERIC_API_ERROR);
    }
    return false;
  };
};

const sucursalCreateAction = data => {
  return async dispatch => {
    try {
      const response = await DataService.post('/sucursal/manage.php', data);
      if (response.status === 200) return true;
      else return false;
    } catch (err) {
      alert(GENERIC_API_ERROR);
    }
    return false;
  };
};

const sucursalReadAction = (id = '') => {
  return async dispatch => {
    try {
      if (id != '') {
        const response = await DataService.get('/sucursal/manage.php?id=' + id);
        if (response.status === 200 && response.data.data) {
          dispatch(sucursalRead(response.data.data));
          return true;
        }
      } else {
        dispatch(sucursalRead({}));
      }
      return false;
    } catch (err) {
      alert(GENERIC_API_ERROR);
    }
    return false;
  };
};

const sucursalUnidadesMedicasListAction = (sucursalId = '') => {
  return async dispatch => {
    try {
      const response = await DataService.get('/sucursal/unidadesMedicas.php?sucursalId=' + sucursalId);
      if (response.status === 200 && response.data.data) {
        // dispatch(sucursalUnidadesMedicasList(response.data.data));
        return response.data.data;
      }
      return [];
    } catch (err) {
      alert(GENERIC_API_ERROR);
    }
    return [];
  };
};

const sucursalUnidadMedicaCreateAction = data => {
  return async dispatch => {
    try {
      const response = await DataService.post('/sucursal/unidadesMedicas.php', data);
      if (response.status === 200) return true;
      else return false;
    } catch (err) {
      alert(GENERIC_API_ERROR);
    }
    return false;
  };
};

const sucursalUnidadesMedicasListClearAction = (sucursalId = '') => {
  return async dispatch => {
    dispatch(sucursalUnidadesMedicasClear());
  };
};

const sucursalUnidadMedicaDeleteAction = data => {
  return async dispatch => {
    try {
      const response = await DataService.delete('/sucursal/unidadesMedicas.php', data);
      if (response.status === 200) return true;
      else return false;
    } catch (err) {
      alert(GENERIC_API_ERROR);
    }
    return false;
  };
};

/////////////////

export {
  sucursalListAction,
  sucursalCreateAction,
  sucursalReadAction,
  sucursalUnidadesMedicasListAction,
  sucursalUnidadMedicaCreateAction,
  sucursalUnidadesMedicasListClearAction,
  sucursalUnidadMedicaDeleteAction,
};
